import { globalEntitlements } from '../utils/globalEntitlements';

export const BUSINESS_KIT_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.businessKit.buyBox.bulletPoint1' },
        { title: 'productPage.businessKit.buyBox.bulletPoint2' }
      ],
      showPreviousPurchasedCallout: true,
      productName: 'productPage.businessKit.buyBox.productName',
      note: 'productPage.businessKit.buyBox.subCopy',
      interactService: {
        ctaType: 'internalCheckout',
        service: 'business_kit'
      }
    }],
    headerPicture: {
      src: '/s2/raster/bizkit-comp-wide.png',
      alt: ''
    },
    headline: 'productPage.businessKit.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.businessKit.page.subheader'
  },
  benefit: {
    title: 'productPage.businessKit.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.businessKit.valueProp.propTitle1',
        description: 'productPage.businessKit.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/eventnoterounded.svg',
        title: 'productPage.businessKit.valueProp.propTitle2',
        description: 'productPage.businessKit.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/contactsrounded.svg',
        title: 'productPage.businessKit.valueProp.propTitle3',
        description: 'productPage.businessKit.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/icon/ribbon-fill.svg',
    title: 'productPage.businessKit.topFeature.title',
    subheader: 'productPage.businessKit.topFeature.subheader',
    image: '/s2/raster/focused-organized-professional.png',
    alt: ''
  },
  whatsIncluded: {
    title: 'productPage.businessKit.whatsIncluded.title',
    items: [
      {
        title: 'productPage.businessKit.whatsIncluded.item1',
        description: 'productPage.businessKit.whatsIncluded.item1ShortDescription'
      },
      {
        title: 'productPage.businessKit.whatsIncluded.item2',
        description: 'productPage.businessKit.whatsIncluded.item2ShortDescription'
      },
      {
        title: 'productPage.businessKit.whatsIncluded.item3',
        description: 'productPage.businessKit.whatsIncluded.item3ShortDescription'
      },
      {
        title: 'productPage.businessKit.whatsIncluded.item4',
        description: 'productPage.businessKit.whatsIncluded.item4ShortDescription'
      },
      {
        title: 'productPage.businessKit.whatsIncluded.item5',
        description: 'productPage.businessKit.whatsIncluded.item5ShortDescription'
      },
      {
        title: 'productPage.businessKit.whatsIncluded.item6',
        description: 'productPage.businessKit.whatsIncluded.item6ShortDescription'
      }
    ],
    image: '/s2/raster/creative-fashion-stylish.png',
    alt: '',
    hasDivider: true,
    hasNumber: false,
    hasMobileImage: false
  },
  assistance: {
    title: 'productPage.businessKit.needAssistance.title',
    getInTouch: 'productPage.businessKit.needAssistance.getInTouch',
    actions: 'productPage.businessKit.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.businessKit.buyBox.buttonLabel' }).allowMultiplePurchases().build()
};
